// 商业智库导航菜单配置
// 使用配置化方式管理菜单，避免代码重复

const navigationConfig = [
  {
    id: 'services',
    labelKey: 'nav.services',
    href: '/#services',
    disableLink: true, // 禁用主导航项跳转
    subItems: [
      { id: 'market-expansion', labelKey: 'services.marketExpansion', href: '/services/market-expansion', isLink: true },
      { id: 'strategic-planning', labelKey: 'services.strategicPlanning', href: '/services/strategic-planning', isLink: true },
      { id: 'investment-analysis', labelKey: 'services.investmentAnalysis', href: '/services/investment-analysis', isLink: true },
      { id: 'policy-compliance', labelKey: 'services.policyCompliance', href: '/services/policy-compliance', isLink: true },
      { id: 'risk-assessment', labelKey: 'services.riskAssessment', href: '/services/risk-assessment', isLink: true },
      // { id: 'localization-strategy', labelKey: 'services.localizationStrategy', href: '/services/localization-strategy', isLink: true }
    ]
  },
  {
    id: 'insights',
    labelKey: 'nav.insights',
    href: '/#insights',
    disableLink: true, // 禁用主导航项跳转
    subItems: [
      { id: 'featured-insights', labelKey: 'insights.featuredInsights', href: '/insights/featured', isLink: true },
      { id: 'market-research', labelKey: 'insights.marketResearch', href: '/insights/market-research', isLink: true }
    ]
  },
  {
    id: 'case-studies',
    labelKey: 'nav.caseStudies',
    href: '/case-studies/all',
    isLink: true // 直接跳转到 all cases 页面
  },
  {
    id: 'about-us',
    labelKey: 'nav.aboutUs',
    href: '/#about-us',
    disableLink: true, // 禁用主导航项跳转
    subItems: [
      { id: 'company-profile', labelKey: 'aboutUs.companyProfile', href: '/about/company-profile', isLink: true },
      // { id: 'our-history', labelKey: 'aboutUs.ourHistory', href: '/about/our-history', isLink: true },
      { id: 'certifications', labelKey: 'aboutUs.certifications', href: '/about/certifications', isLink: true }
    ]
  },
  {
    id: 'connect-us',
    labelKey: 'nav.connectUs',
    href: '/connect-us',
    isLink: true,
    target: '_blank',
    rel: 'noopener noreferrer'
  }
];

export default navigationConfig;
